import { render, staticRenderFns } from "./VerifyDefinitive.vue?vue&type=template&id=0b2ab56e&scoped=true&"
import script from "./VerifyDefinitive.vue?vue&type=script&lang=js&"
export * from "./VerifyDefinitive.vue?vue&type=script&lang=js&"
import style0 from "./VerifyDefinitive.vue?vue&type=style&index=0&id=0b2ab56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ab56e",
  null
  
)

export default component.exports